// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__11C-9","title":"ClientReferral_title__32d_m","itemText":"ClientReferral_itemText__2oD4s"};